import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./MapCatalog.css";

// Fix default marker icon paths (needed because of CRA bundling)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// OpenStreetMap standard tiles — no API key required. Dark look achieved via
// CSS filter on .leaflet-tile-pane (see MapCatalog.css .vd-map-root rule).
const TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const TILE_ATTRIBUTION = '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export default function PropertyMap({ lat, lng, city, locked }) {
    const ref = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        if (!ref.current || mapRef.current) return;
        const map = L.map(ref.current, {
            center: [lat || 41.9028, lng || 12.4964],
            zoom: locked ? 11 : 15,
            zoomControl: true,
            scrollWheelZoom: false,
        });
        L.tileLayer(TILE_URL, {
            attribution: TILE_ATTRIBUTION,
            subdomains: "abc",
            maxZoom: 19,
        }).addTo(map);
        if (lat && lng) {
            if (locked) {
                L.circle([lat, lng], { radius: 600, color: "#D4AF6A", weight: 1, fillOpacity: 0.15 }).addTo(map);
            } else {
                L.marker([lat, lng]).addTo(map);
            }
        }
        mapRef.current = map;
        return () => { map.remove(); mapRef.current = null; };
    }, [lat, lng, locked]);

    return (
        <div className="border border-white/10">
            <div ref={ref} className="vd-locator-map-dark" data-testid="property-map" style={{ height: 360, width: "100%", background: "#0a0a0a" }} />
            {locked && (
                <div className="px-4 py-3 text-xs text-ink-400 border-t border-white/5 flex items-center gap-2">
                    <span className="text-gold">●</span>
                    Posizione approssimativa — l'indirizzo esatto è riservato agli abbonati.
                </div>
            )}
        </div>
    );
}
